<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Register</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="update()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-list>
    @if (registers && registers.length) {
      <ion-radio-group [(ngModel)]="selected_register_id">
        @for (register of registers; track register) {
          <ion-item lines="full">
            <ion-radio class="primary" labelPlacement="start" value="{{ register.id }}">{{register.title}}</ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
  </ion-list>

</ion-content>